(function () {
    'use strict';

    var module = angular.module('uwAgenda.agenda');
    module.factory('AppointmentDetailService', [
        '$rootScope', 
        '$uibModal', 
        '$q', 
        'Alert', 
        'DateService',
        'CallsService',
        'ContactInfo',
        AppointmentDetailServiceFn]);

    // main service for new/edit an appointment 
    function AppointmentDetailServiceFn($rootScope, 
                                        $uibModal, 
                                        $q, 
                                        Alert, 
                                        DateService,
                                        CallsService,
                                        ContactInfo){
        // main data
        var data = {
            agenda: null, // current agenda
            appointment: null, // current appointment
            time: {
                hour: null,
                minute: null
            }, // the selected time of a label. to check if it is in the past
            doTimeChecks: true, // indicates, if time-checks should be done...no checks if appointment will be edit

            email: {}, // main email 
            mobile: {}, // main mobile
            labels: [], // possible labels to select 
            types: {},  // possible appointment-types by agenda-labels
            agendaItem: {}, // Agenda-Item If Double-Booking Available
            // list of matching patients for a user coming from an external system
            matchingExternalPatients: []
        };        

        var service = {
            data: data,            
            clear: clear,
            setEmail: setEmail,
            setMobile: setMobile,
            inThePast: inThePast,
            show: show,
            historie: historie,
            reminder: reminder,
            modification: modification,
            afterNewAppointment: afterNewAppointment,
            generateNeededContactInfoTypes: generateNeededContactInfoTypes
        };

        // clear
        function clear() {
            data.agenda = null;
            data.agendaItem = null;
            data.appointment = null;
        }

        // set email text
        function setEmail(name, email) {
            data.email = name;
            if (email !== null) {
                data.email += ' (' + email + ')';
            } //if
        }

        // set mobile text
        function setMobile(name, mobile) {
            data.mobile = name;
            if (mobile !== null) {
                data.mobile += ' (' + mobile + ')';
            } //if
        }

        // is time in the past
        function inThePast() {
            // if no checks -> it is ok
            if (!data.doTimeChecks || 
                (data.appointment && data.appointment.id > 0)) {
                     return promise(false); 
            }

            // current selected date
            var date = new Date(DateService.data.date);

            // check date
            if (data.time.hour !== null && data.time.minute !== null) {
                // build item-date              

                // set hour and minutes
                date.setHours(data.time.hour);
                date.setMinutes(data.time.minute);
                date.setSeconds(0);

            }

            var now = new Date();
            
            var midnightToday = new Date();
            midnightToday.setHours(0, 0, 0, 0);

            var timeBeforeToday = date < midnightToday;

            // show message that the selected time if before today
            if (timeBeforeToday && 
                data.agenda && 
                !data.agenda.allowBookingAppointmentsBeforeToday) {
                return timeInPastModal(timeBeforeToday).result;
            }

            var timeInThePast = date < now;
            // if it is NOT in the Past -> go further, its ok
            if (!timeInThePast) {
                return promise(timeInThePast);
            }

            // show question if the use wants to proceed with booking an appointment in the past
            return timeInPastModal(false).result;
        } 

        // return a promise result
        function promise(result) {
            return $q(function (resolve) {
                resolve(result);
            });
        }

        // show time in past modal
        function timeInPastModal(timeBeforeToday) {
            // show modal
            return $uibModal.open({
                backdrop: false,
                keyboard: false,
                animation: true,
                templateUrl: '/app/agenda/templates/agenda-appointment-time-past-modal.template.html',
                controller: 'AgendaAppointmentTimePastModalController',
                controllerAs: 'vm',
                size: 'xs',
                resolve: {
                    timeBeforeToday: function () {
                      return timeBeforeToday;
                    },
                  },
            });
        }

        // show modal with appoitment-detail-information
        function show(id, agendaId) {
            // show modal
            var modalInstance = $uibModal.open({
                backdrop: true,
                keyboard: true,
                animation: true,
                windowClass: 'modal-to-right',
                templateUrl: '/app/agenda/templates/agenda-appointment-info.template.html',
                controller: 'AgendaAppointmentInfoController',
                controllerAs: 'vm',
                size: 'lg',
                resolve: {
                    appointment: ['AppointmentService', function (AppointmentService) {
                        return AppointmentService.get(id, agendaId);
                    }]
                }
            });

            // when modal is closed
            modalInstance.result.then(function () {
            }, function () {
                // dismissed
            });
        }

        // show modal with last-appointments (historie) of user
        function historie(id, patientCaption) {
            // show modal
            var modalInstance = $uibModal.open({
                backdrop: true,
                keyboard: true,
                animation: true,
                windowClass: 'modal-to-right',
                templateUrl: '/app/agenda/templates/agenda-appointment-last-appointments.template.html',
                controller: 'AgendaAppointmentsLastAppointmentsController',
                controllerAs: 'vm',
                size: 'lg',
                resolve: {
                    id: function () {
                        return id;
                    },
                    patientCaption: function() {
                        return patientCaption;
                    }
                }
            });

            // when modal is closed
            modalInstance.result.then(function () {
            }, function () {
                // dismissed
            });
        }

        // show modal with reminder
        function reminder(id) {
            // show modal
            var modalInstance = $uibModal.open({
                backdrop: true,
                keyboard: true,
                animation: true,
                windowClass: 'modal-to-right',
                templateUrl: '/app/agenda/templates/agenda-appointment-reminder-modal.template.html',
                controller: 'AgendaAppointmentsReminderModalController',
                controllerAs: 'vm',
                size: 'lg',
                resolve: {
                    reminders: ['AppointmentService', function (AppointmentService) {
                        return AppointmentService.reminderMessages(id);
                    }]
                }
            });

            // when modal is closed
            modalInstance.result.then(function () {
            }, function () {
                // dismissed
            });
        }
        function modification(id, appointment) {
            // show modal
            var modalInstance = $uibModal.open({
                backdrop: true,
                keyboard: true,
                animation: true,
                windowClass: 'modal-to-right',
                templateUrl: '/app/agenda/templates/agenda-appointment-modification-modal.template.html',
                controller: 'AgendaAppointmentsModificationsModalController',
                controllerAs: 'vm',
                size: 'lg',
                resolve: {
                    modifications: ['AppointmentService', function (AppointmentService) {
                        return AppointmentService.appointmentModifications(id);
                    }],
                    appointment:[function(){
                        return appointment;
                    }]
                }
            });

            // when modal is closed
            modalInstance.result.then(function () {
            }, function () {
                // dismissed
            });
        }

        // show after new appointment
        function afterNewAppointment(text) {
            // show modal
            var modalInstance = $uibModal.open({
                backdrop: true,
                keyboard: true,
                animation: true,
                templateUrl: '/app/agenda/templates/agenda-after-new-appointment-modal.template.html',                
                controller: 'AgendaAfterNewAppointmentModalController',
                controllerAs: 'vm',
                size: 'md',
                resolve: {
                    message: function () {
                        return text;
                    }
                }
            });

            // when modal is closed
            modalInstance.result.then(function () {
            }, function () {
                // dismissed
            });
        }

        // generate needed contact-info-types specified by agenda
        function generateNeededContactInfoTypes(patientContactInfos, alreadyExistingContactInfoTypes) {            
            // depending on agenda-settings -> show needed contact-info-types
            // all existing contact-infos from user will be displayed

            // if (!alreadyExistingContactInfoTypes || alreadyExistingContactInfoTypes.length === 0) {
            //     return;
            // }

            // list of contact-infos to show
            var contactInfos = [];

            var len = 0;

            // iterate over existing contact-infos of patient and make new objects for frontend
            if (typeof patientContactInfos !== 'undefined' && patientContactInfos !== null) {
                var i = 0;
                len = patientContactInfos.length;

                // generate items...
                for (i; i < len; i++) {
                    // new object
                    var nuci = new ContactInfo();
                    nuci.extend(patientContactInfos[i]);
                    nuci.selected = false;

                    // show contact-info of type
                    contactInfos.push(nuci);
                } // for

            } // if


            // Now have a look, if the NEEDED/REQUIRED Contact-Infos of that agenda are present and selected -> otherwise create it
            var j = 0;
            len = alreadyExistingContactInfoTypes.length;
            // check and create if needed
            for (j; j < len; j++) {

                // search current needed contact-info in the patient-contact-infos
                var k = 0;
                var pLen = contactInfos.length;

                // found the needed one ?
                var found = false;

                // search
                for (k; k < pLen; k++) {
                    // check the type of the contact-infos
                    var uci = contactInfos[k];
                    if (alreadyExistingContactInfoTypes[j].type === uci.userContactInfoType.type) {
                        // FOUND !
                        found = true;

                        // select it...
                        uci.selected = true;

                        break;
                    } //if
                } // for

                // If NOT found -> create 
                if (!found) {
                    // create new contact-info with current type
                    var ci = new ContactInfo();
                    ci.init(alreadyExistingContactInfoTypes[j]);
                    // selected for appointment
                    ci.selected = true;
                    ci.showInContactDetails = true
                    contactInfos.push(ci);
                } // if

            } // for

            // set contact-info array
            return contactInfos;
        }



        return service;

    }
})();